(function () {
    'use strict';

    angular
        .module('homeMyTasksControllers')
        .controller('MyTasksActionPlanStatusUpdateController', Controller);

    Controller.$inject = ['$scope', '$state', 'recomActionPlanUpdateStatusService'];

    function Controller($scope, $state, recomActionPlanUpdateStatusService) {

        var ownerId = $scope.authenticatedUser.ItemPersonID;
        $scope.actionPlanStatusUpdateTasks = [];

        recomActionPlanUpdateStatusService
            .getOwnerTasks()
            .then(function (ownerTasks) {
               _.chain(ownerTasks)
                .filter(function (bUnitTask) { return bUnitTask.NbTasks > 0;})
                .each(function (businessUnitTask) {
                    $scope.tasksCountByName['actionPlanStatusUpdateTask' + businessUnitTask.Code] = businessUnitTask.NbTasks;

                    $scope.actionPlanStatusUpdateTasks.push({
                        businessUnit: businessUnitTask,
                        nbTasks: businessUnitTask.NbTasks
                    })
                })
                .value();
            });

        // Go To Action Plan Update Status
        $scope.goToActionPlanStatusUpdate = function (businessUnitCode) {
            $state.go('recomActionPlanUpdateStatusAssess', {
                ItemPersonID: ownerId,
                BusinessUnitCode: businessUnitCode
            });
        };
    }
})();